import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useLocation, useHistory } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import Unauthorized from "../general/Unauthorized";
import { Modal, Button } from "react-bootstrap";

function CrearFacturaNoElectronica() {
    const location = useLocation();
    const history = useHistory();
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);

    // Estados del formulario
    const [fecha, setFecha] = useState(new Date().toISOString().split('T')[0]);
    const [vencimiento, setVencimiento] = useState(new Date().toISOString().split('T')[0]);
    const [profesional, setProfesional] = useState('');
    const [metodoPago, setMetodoPago] = useState('10');
    const [tipoPago, setTipoPago] = useState('contado');

    // Estados para datos de API
    const [profesionales, setProfesionales] = useState([]);

    // Estados del paciente
    const [pacienteId, setPacienteId] = useState('');
    const [nombrePaciente, setNombrePaciente] = useState('');
    const [tipoPaciente, setTipoPaciente] = useState('CC');
    const [documentoPaciente, setDocumentoPaciente] = useState('');

    // Estados de productos
    const [productos, setProductos] = useState([]);
    const [productoSeleccionado, setProductoSeleccionado] = useState('');
    const [totalBruto, setTotalBruto] = useState(0);
    const [totalDescuento, setTotalDescuento] = useState(0);
    const [totalIVA, setTotalIVA] = useState(0);
    const [totalPagar, setTotalPagar] = useState(0);

    // Estados para lista de precios
    const [listaPrecios, setListaPrecios] = useState([]);
    const [clasificacionFiltro, setClasificacionFiltro] = useState('');
    const [buscarServicio, setBuscarServicio] = useState('');
    const [mostrarOpcionesServicio, setMostrarOpcionesServicio] = useState(false);
    const [especialidades, setEspecialidades] = useState([]);
    const [impuestos, setImpuestos] = useState([]);

    const [observaciones, setObservaciones] = useState('');
    const [showModalPaciente, setShowModalPaciente] = useState(false);
    const [pacientes, setPacientes] = useState([]);
    const [busquedaPaciente, setBusquedaPaciente] = useState('');
    const [paginaActual, setPaginaActual] = useState(1);
    const pacientesPorPagina = 10;

    // Estados para modal de éxito
    const [showModalExito, setShowModalExito] = useState(false);
    const [numeroFacturaCreada, setNumeroFacturaCreada] = useState('');
    const [facturaIdCreada, setFacturaIdCreada] = useState(null);
    const [origenNavegacion, setOrigenNavegacion] = useState(null); // 'presupuesto' | 'factura' | null
    const [pacienteIdParaCartera, setPacienteIdParaCartera] = useState(null);

    // Estados para presupuesto activo
    const [presupuestoActivo, setPresupuestoActivo] = useState(null);
    const [presupuestosActivos, setPresupuestosActivos] = useState([]);
    const [saldoDisponible, setSaldoDisponible] = useState(0);
    const [copiarItemsPresupuesto, setCopiarItemsPresupuesto] = useState(false);

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a crear facturas no electrónicas
        const tienePermiso = userdata.up && userdata.up.includes('facturacion');

        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Verificar si viene un presupuesto en la URL
        const searchParams = new URLSearchParams(location.search);
        const presupuestoId = searchParams.get('presupuesto');
        const presupuestoActivoId = searchParams.get('presupuesto_activo');

        if (presupuestoActivoId) {
            setOrigenNavegacion('presupuesto');
            cargarPresupuestoActivoDesdeUrl(presupuestoActivoId, config);
        } else if (presupuestoId) {
            cargarPresupuesto(presupuestoId);
        }

        // Cargar profesionales
        axios.get('/usuarios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setProfesionales(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar pacientes
        axios.get('/pacientes?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setPacientes(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar especialidades
        axios.get('/especialidades-referencia?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setEspecialidades(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar lista de precios
        axios.get('/lista-precios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setListaPrecios(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar impuestos (tabla maestra - sin filtro por client_id)
        axios.get('/administrador-impuestos', config)
            .then(response => {
                if (response.status === 200) {
                    setImpuestos(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    }, []);

    const getClasificacionesDinamicas = () => {
        const clasificaciones = Array.from(
            new Set(
                listaPrecios
                    .map(item => (item.clasificacion || '').trim())
                    .filter(Boolean)
            )
        );
        return clasificaciones.sort((a, b) => a.localeCompare(b));
    };

    const getListaPreciosFiltrada = () => {
        let filtrada = listaPrecios;

        if (clasificacionFiltro) {
            filtrada = filtrada.filter(item => item.clasificacion === clasificacionFiltro);
        }

        if (buscarServicio.trim()) {
            const term = buscarServicio.toLowerCase();
            filtrada = filtrada.filter(item =>
                (item.nombre || '').toLowerCase().includes(term) ||
                (item.codigo || '').toLowerCase().includes(term)
            );
        }

        return filtrada;
    };

    const agregarServicio = () => {
        const servicio = listaPrecios.find(s => s.id == productoSeleccionado);
        if (servicio) {
            const nuevoProducto = {
                id: Date.now(),
                id_listadeprecios: servicio.id,
                codigo: servicio.codigo,
                clasificacion: servicio.clasificacion || '',
                descripcion: servicio.nombre,
                cantidad: 1,
                precio: parseFloat(servicio.precio),
                porcentaje: 0,
                impuesto: 0,
                total: parseFloat(servicio.precio)
            };
            setProductos([...productos, nuevoProducto]);
            calcularTotales([...productos, nuevoProducto]);
            setProductoSeleccionado('');
            setBuscarServicio('');
            setMostrarOpcionesServicio(false);
        }
    };

    const eliminarProducto = (id) => {
        const nuevosProductos = productos.filter(p => p.id !== id);
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const actualizarProducto = (id, campo, valor) => {
        const nuevosProductos = productos.map(p => {
            if (p.id === id) {
                const productoActualizado = { ...p, [campo]: parseFloat(valor) || 0 };

                // Recalcular total del producto
                const descuento = (productoActualizado.precio * productoActualizado.cantidad) * (productoActualizado.porcentaje / 100);
                const totalBase = (productoActualizado.precio * productoActualizado.cantidad) - descuento;
                const totalConImpuesto = totalBase + (totalBase * (productoActualizado.impuesto / 100));
                productoActualizado.total = totalConImpuesto;

                return productoActualizado;
            }
            return p;
        });
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const calcularTotales = (productosArray) => {
        let subtotal = 0;
        let totalDescuentos = 0;
        let totalImpuestos = 0;
        let total = 0;

        productosArray.forEach(producto => {
            const precioBase = producto.precio * producto.cantidad;
            const descuento = precioBase * (producto.porcentaje / 100);
            const baseConDescuento = precioBase - descuento;
            const impuesto = baseConDescuento * (producto.impuesto / 100);

            subtotal += precioBase;
            totalDescuentos += descuento;
            totalImpuestos += impuesto;
            total += producto.total;
        });

        setTotalBruto(subtotal);
        setTotalDescuento(totalDescuentos);
        setTotalIVA(totalImpuestos);
        setTotalPagar(total);
    };

    const getPacientesFiltrados = () => {
        if (!busquedaPaciente) return pacientes;

        return pacientes.filter(paciente => {
            const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim().toLowerCase();
            const documento = paciente.numero_documento || '';
            const busqueda = busquedaPaciente.toLowerCase();

            return nombreCompleto.includes(busqueda) || documento.includes(busqueda);
        });
    };

    const getPacientesPaginados = () => {
        const pacientesFiltrados = getPacientesFiltrados();
        if (pacientesFiltrados.length === 0) return [];
        const totalPag = Math.ceil(pacientesFiltrados.length / pacientesPorPagina);
        const page = Math.min(Math.max(1, paginaActual), totalPag);
        const inicio = (page - 1) * pacientesPorPagina;
        return pacientesFiltrados.slice(inicio, inicio + pacientesPorPagina);
    };

    const getTotalPaginas = () => {
        return Math.ceil(getPacientesFiltrados().length / pacientesPorPagina);
    };

    useEffect(() => {
        setPaginaActual(1);
    }, [busquedaPaciente]);

    useEffect(() => {
        if (showModalPaciente) {
            setPaginaActual(1);
        }
    }, [showModalPaciente]);

    const seleccionarPaciente = (paciente) => {
        const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
        setPacienteId(paciente.id);
        setNombrePaciente(nombreCompleto);
        setTipoPaciente(paciente.tipo_documento || 'CC');
        setDocumentoPaciente(paciente.numero_documento || '');
        setShowModalPaciente(false);

        // Limpiar presupuesto activo anterior y cargar los del nuevo paciente
        setPresupuestoActivo(null);
        setSaldoDisponible(0);
        setCopiarItemsPresupuesto(false);
        cargarPresupuestosActivos(paciente.id);
    };

    // Funciones para modal de éxito
    const handleShowModalExito = () => setShowModalExito(true);
    const handleCloseModalExito = () => {
        setShowModalExito(false);
        // Opcional: redirigir al listado de facturas
        // history.push('/listado-facturas');
    };

    const cargarPresupuesto = async (presupuestoId) => {
        try {
            // Cargar datos del presupuesto - usar la misma URL que funciona en CrearFactura
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            const response = await axios.get(`/presupuesto/${presupuestoId}?uid=${userdata.user_id}`);

            if (response.status === 200 && response.data) {
                const presupuesto = response.data;

                // El ID del paciente viene del presupuesto
                const pacienteId = presupuesto.paciente_id;
                setPacienteId(pacienteId);
                setProfesional(presupuesto.users_id.toString());

                // Cargar datos del paciente para mostrar nombre y documento
                const pacienteResponse = await axios.get(`/paciente?uid=${userdata.user_id}&id=${presupuesto.paciente_id}`);
                if (pacienteResponse.data && pacienteResponse.data.length > 0) {
                    const paciente = pacienteResponse.data[0];
                    const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
                    setNombrePaciente(nombreCompleto);
                    setTipoPaciente(paciente.tipo_documento || 'CC');
                    setDocumentoPaciente(paciente.numero_documento || '');
                }

                // Cargar detalle del presupuesto - usar la misma lógica que CrearFactura
                if (presupuesto.detalle) {
                    const productosPresupuesto = presupuesto.detalle.map(item => ({
                        id: Date.now() + Math.random(),
                        id_listadeprecios: item.id_listadeprecios,
                        codigo: item.lista_precio?.codigo || item.codigo || '',
                        clasificacion: item.lista_precio?.clasificacion || '',
                        descripcion: item.lista_precio?.nombre || item.nombre || item.descripcion || '',
                        cantidad: parseFloat(item.cantidad) || 1,
                        precio: parseFloat(item.precio_unitario) || 0,
                        porcentaje: parseFloat(item.porcentaje) || 0,
                        impuesto: parseFloat(item.impuesto) || 0,
                        total: parseFloat(item.total) || 0
                    }));

                    setProductos(productosPresupuesto);
                    calcularTotales(productosPresupuesto);
                }

                if (presupuesto.observaciones) {
                    setObservaciones(presupuesto.observaciones);
                }
            }
        } catch (error) {
            console.log('Error cargando presupuesto:', error);
            alert('Error al cargar el presupuesto: ' + (error.response?.data?.message || error.message));
        }
    };

    // Cargar presupuestos activos de un paciente
    const cargarPresupuestosActivos = async (pacienteIdParam) => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };
        try {
            const response = await axios.get(`/presupuestos/paciente/${pacienteIdParam}/activos?uid=${userdata.user_id}`, config);
            if (response.status === 200) {
                setPresupuestosActivos(response.data.presupuestos || []);
            }
        } catch (error) {
            console.error('Error al cargar presupuestos activos:', error);
            setPresupuestosActivos([]);
        }
    };

    // Precargar presupuesto activo desde URL param (navegación desde EditarPresupuesto)
    const cargarPresupuestoActivoDesdeUrl = async (presupuestoActivoId, configParam) => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = configParam || {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };
        try {
            const response = await axios.get(`/presupuesto/${presupuestoActivoId}?uid=${userdata.user_id}`, config);
            const presupuestoData = response.data;

            if (presupuestoData && presupuestoData.paciente_id) {
                // Cargar datos del paciente
                const pacienteResponse = await axios.get(`/paciente?uid=${userdata.user_id}&id=${presupuestoData.paciente_id}`, config);
                if (pacienteResponse.data && pacienteResponse.data.length > 0) {
                    const paciente = pacienteResponse.data[0];
                    const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
                    setPacienteId(presupuestoData.paciente_id);
                    setNombrePaciente(nombreCompleto);
                    setTipoPaciente(paciente.tipo_documento || 'CC');
                    setDocumentoPaciente(paciente.numero_documento || '');
                }

                // Cargar presupuestos activos del paciente
                await cargarPresupuestosActivos(presupuestoData.paciente_id);

                // Seleccionar automáticamente el presupuesto activo
                if (presupuestoData.estado === 1) {
                    setPresupuestoActivo(presupuestoData);
                    setSaldoDisponible(parseFloat(presupuestoData.saldo_disponible) || 0);
                    // Precargar profesional del presupuesto
                    if (presupuestoData.users_id) {
                        setProfesional(presupuestoData.users_id.toString());
                    }
                    // Guardar paciente para cartera
                    setPacienteIdParaCartera(presupuestoData.paciente_id);
                }
            }
        } catch (error) {
            console.error('Error al cargar presupuesto activo desde URL:', error);
        }
    };

    // Manejar selección de presupuesto activo del dropdown
    const handleSeleccionPresupuestoActivo = async (e) => {
        const selectedId = e.target.value;
        if (!selectedId) {
            setPresupuestoActivo(null);
            setSaldoDisponible(0);
            setCopiarItemsPresupuesto(false);
            return;
        }

        const selected = presupuestosActivos.find(p => p.id == selectedId);
        if (selected) {
            setPresupuestoActivo(selected);
            setSaldoDisponible(parseFloat(selected.saldo_disponible) || 0);
            setCopiarItemsPresupuesto(false);
        }
    };

    // Copiar ítems del presupuesto activo seleccionado
    const copiarItemsDePresupuesto = async () => {
        if (!presupuestoActivo) return;

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };
        try {
            const response = await axios.get(`/presupuesto/${presupuestoActivo.id}?uid=${userdata.user_id}`, config);
            const presupuestoData = response.data;

            if (presupuestoData && presupuestoData.detalle) {
                const productosPresupuesto = presupuestoData.detalle.map(item => ({
                    id: Date.now() + Math.random(),
                    id_listadeprecios: item.id_listadeprecios,
                    codigo: item.lista_precio?.codigo || item.codigo,
                    clasificacion: item.lista_precio?.clasificacion || '',
                    descripcion: item.lista_precio?.nombre || item.nombre,
                    cantidad: item.cantidad,
                    precio: parseFloat(item.precio_unitario),
                    porcentaje: parseFloat(item.porcentaje),
                    impuesto: parseFloat(item.impuesto),
                    total: parseFloat(item.total)
                }));

                setProductos(productosPresupuesto);
                calcularTotales(productosPresupuesto);
                setCopiarItemsPresupuesto(true);
            }
        } catch (error) {
            console.error('Error al copiar ítems del presupuesto:', error);
            alert('Error al cargar los ítems del presupuesto');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!pacienteId || !profesional || productos.length === 0) {
            alert('Por favor complete todos los campos requeridos y agregue al menos un producto');
            return;
        }

        // Validar saldo si hay presupuesto activo seleccionado
        if (presupuestoActivo && totalPagar > saldoDisponible) {
            alert(`El valor de la factura (${parseFloat(totalPagar).toLocaleString('es-CO', {minimumFractionDigits: 2})}) excede el saldo pendiente del presupuesto (${parseFloat(saldoDisponible).toLocaleString('es-CO', {minimumFractionDigits: 2})})`);
            return;
        }

        const facturaData = {
            users_id: parseInt(profesional),
            paciente_id: parseInt(pacienteId),
            fecha_emision: fecha,
            fecha_vence: vencimiento,
            forma_pago: metodoPago,
            tipo_pago: tipoPago,
            valor_bruto: totalBruto,
            valor_total: totalPagar,
            observaciones: observaciones,
            presupuesto_id: presupuestoActivo ? parseInt(presupuestoActivo.id) : null,
            detalle: productos.map(p => ({
                id_listadeprecios: p.id_listadeprecios,
                cantidad: p.cantidad,
                precio_unitario: p.precio,
                porcentaje: p.porcentaje,
                impuesto: p.impuesto,
                total: p.total
            }))
        };

        try {
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            const config = {
                headers: {
                    Authorization: 'Bearer ' + userdata.access_token
                }
            };

            const response = await axios.post('/factura-no-electronica', facturaData, config);

            if (response.status === 201) {
                const facturaId = response.data.factura_id;
                const numeroFactura = response.data.numero_factura || 'N/A';

                if (tipoPago === 'credito') {
                    // Crear registro en cuentas por cobrar para facturas a crédito
                    const cuentaData = {
                        factura_id: facturaId,
                        valor_total: totalPagar,
                        valor_pagado: 0,
                        valor_pendiente: totalPagar,
                        fecha_vencimiento: vencimiento
                    };

                    try {
                        await axios.post('/cuentas-por-cobrar', cuentaData, config);
                    } catch (error) {
                        console.log('Error creando cuenta por cobrar:', error);
                    }
                }

                // Guardar datos de la factura creada
                setNumeroFacturaCreada(numeroFactura);
                setFacturaIdCreada(facturaId);
                // Guardar paciente para cartera (antes de limpiar)
                setPacienteIdParaCartera(pacienteId || pacienteIdParaCartera);

                // Limpiar formulario
                setProductos([]);
                setPacienteId('');
                setNombrePaciente('');
                setDocumentoPaciente('');
                setObservaciones('');
                setTotalBruto(0);
                setTotalDescuento(0);
                setTotalIVA(0);
                setTotalPagar(0);
                setPresupuestoActivo(null);
                setPresupuestosActivos([]);
                setSaldoDisponible(0);
                setCopiarItemsPresupuesto(false);

                // Mostrar modal de éxito
                setTimeout(() => { handleShowModalExito() }, 500);
            }
        } catch (error) {
            console.log('Error completo:', error);
            alert('Error al guardar la factura: ' + (error.response?.data?.message || error.message));
        }
    };

    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            <div className="hold-transition factura-page">
                <style>{`
                    .factura-page { font-size: 12.5px; }
                    .factura-page .content-header h1 {
                        font-size: 1.9rem !important;
                        font-weight: 800 !important;
                        margin-bottom: 0 !important;
                    }
                    .factura-page label {
                        font-size: 0.76rem;
                        font-weight: 700;
                        color: #6c757d;
                        margin-bottom: 6px;
                        text-transform: uppercase;
                        letter-spacing: .03rem;
                    }
                    .factura-page .form-control {
                        font-size: 0.82rem !important;
                        padding: 0.38rem 0.68rem !important;
                        min-height: 36px;
                    }
                    .factura-page .btn { font-size: 0.82rem !important; }
                    .factura-soft-card {
                        border-radius: 16px !important;
                        border: 1px solid rgba(0,0,0,0.05) !important;
                        box-shadow: 0 10px 24px rgba(0,0,0,0.04) !important;
                    }
                    .factura-soft-header {
                        background: #fff;
                        border-bottom: 1px solid rgba(0,0,0,0.06);
                    }
                    .factura-main-title {
                        margin: 0;
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        font-size: 1rem;
                        font-weight: 800;
                        color: #323a45;
                    }
                    .factura-main-title .title-icon {
                        width: 28px;
                        height: 28px;
                        border-radius: 9px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        background: rgba(23,162,184,0.1);
                        color: #17a2b8;
                        font-size: 0.85rem;
                    }
                    .factura-section-title {
                        margin: 0 0 14px 0;
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        font-size: 0.95rem;
                        font-weight: 800;
                        color: #323a45;
                    }
                    .factura-section-title .title-icon {
                        width: 26px;
                        height: 26px;
                        border-radius: 8px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        background: rgba(50,58,69,0.08);
                        color: #323a45;
                        font-size: 0.78rem;
                    }
                    .factura-soft-banner {
                        border-radius: 14px;
                        border: 1px solid rgba(23,162,184,0.20);
                        background: linear-gradient(135deg, rgba(23,162,184,0.08) 0%, rgba(50,58,69,0.04) 100%);
                        padding: 10px 12px;
                        font-weight: 700;
                        color: #323a45;
                    }
                    .factura-soft-alert {
                        border-radius: 12px;
                        border: 1px solid rgba(220,53,69,0.2);
                        background: rgba(220,53,69,0.08);
                        color: #8a2d2d;
                    }
                    .chip-row {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 8px;
                    }
                    .chip-filter {
                        border: 1px solid rgba(23,162,184,0.25);
                        background: rgba(23,162,184,0.06);
                        color: #17a2b8;
                        border-radius: 999px;
                        padding: 5px 12px;
                        font-size: 0.75rem;
                        font-weight: 700;
                        cursor: pointer;
                    }
                    .chip-filter.active {
                        background: #17a2b8;
                        color: #fff;
                        border-color: #17a2b8;
                    }
                    /* Modal éxito / paciente — mismo criterio que listados (cabecera suave, cuerpo con scroll) */
                    .cf-ne-exito-dialog {
                        max-width: 480px;
                    }
                    .cf-ne-exito-content {
                        border-radius: 16px !important;
                        border: 1px solid rgba(0,0,0,0.08) !important;
                        box-shadow: 0 12px 32px rgba(0,0,0,0.1) !important;
                        overflow: hidden;
                    }
                    .cf-ne-exito-head.modal-header {
                        background: #f8f9fa !important;
                        border-bottom: 1px solid rgba(0,0,0,0.06) !important;
                    }
                    .cf-ne-exito-head .modal-title {
                        font-size: 1rem;
                        font-weight: 700;
                        color: #323a45;
                    }
                    .cf-ne-alert-success-soft {
                        border-radius: 12px;
                        border: 1px solid rgba(40, 167, 69, 0.32);
                        background: rgba(40, 167, 69, 0.09);
                        color: #155724;
                        padding: 12px 14px;
                        font-size: 0.875rem;
                        text-align: left;
                    }
                    .cf-ne-alert-info-soft {
                        border-radius: 12px;
                        border: 1px solid rgba(23, 162, 184, 0.28);
                        background: rgba(23, 162, 184, 0.09);
                        color: #0c5460;
                        padding: 12px 14px;
                        font-size: 0.875rem;
                        text-align: left;
                    }
                    .cf-ne-modal-paciente .modal-dialog {
                        max-height: calc(100vh - 1rem);
                        margin: 0.5rem auto;
                    }
                    .cf-ne-modal-paciente .modal-content {
                        max-height: calc(100vh - 1rem);
                        display: flex;
                        flex-direction: column;
                        border-radius: 16px !important;
                        border: 1px solid rgba(0,0,0,0.08) !important;
                        box-shadow: 0 12px 32px rgba(0,0,0,0.1) !important;
                        overflow: hidden;
                    }
                    .cf-ne-modal-paciente .cf-ne-paciente-head {
                        background: #f8f9fa !important;
                        border-bottom: 1px solid rgba(0,0,0,0.06) !important;
                    }
                    .cf-ne-modal-paciente .cf-ne-paciente-head .modal-title {
                        font-size: 1rem;
                        font-weight: 700;
                        color: #323a45;
                    }
                    .cf-ne-modal-paciente .cf-ne-paciente-head .close {
                        color: #323a45;
                        opacity: 0.65;
                        text-shadow: none;
                    }
                    .cf-ne-modal-paciente .cf-ne-paciente-body {
                        display: flex;
                        flex-direction: column;
                        min-height: 0;
                        flex: 1 1 auto;
                        overflow: hidden;
                    }
                    .cf-ne-modal-paciente .cf-ne-paciente-table-wrap {
                        overflow-y: auto;
                        -webkit-overflow-scrolling: touch;
                        flex: 1 1 auto;
                        min-height: 0;
                        max-height: min(52vh, 440px);
                        border: 1px solid #e9ecef;
                        border-radius: 10px;
                        background: #fff;
                    }
                    .cf-ne-modal-paciente .cf-ne-paciente-table-wrap table {
                        margin-bottom: 0;
                        font-size: 0.82rem;
                    }
                    .cf-ne-modal-paciente .cf-ne-paciente-table-wrap thead th {
                        position: sticky;
                        top: 0;
                        z-index: 1;
                        background: #f8f9fa;
                        color: #7d7d7d;
                        font-size: 0.68rem;
                        font-weight: 700;
                        text-transform: uppercase;
                        border-bottom: 1px solid #e9ecef;
                    }
                    .cf-ne-paciente-pag {
                        flex-shrink: 0;
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="billing" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                        <li className="breadcrumb-item"><Link to="/listado-facturas">Listado de Facturas</Link></li>
                                        <li className="breadcrumb-item active">Crear Factura No Electrónica</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Crear Factura No Electrónica</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">

                            <div className="card card-info card-outline factura-soft-card">
                                <div className="card card-info-outline">
                                    <div className="card-header factura-soft-header">
                                        <h5 className="factura-main-title">
                                            <span className="title-icon"><i className="fas fa-file-invoice"></i></span>
                                            Información de la Factura
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>

                                            <h5 className="factura-section-title">
                                                <span className="title-icon"><i className="fas fa-user"></i></span>
                                                Información del Paciente
                                            </h5>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Nombre *</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={nombrePaciente}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Tipo *</label>
                                                        <select
                                                            className="form-control"
                                                            value={tipoPaciente}
                                                            readOnly
                                                            required
                                                        >
                                                            <option value="CC">CC</option>
                                                            <option value="CE">CE</option>
                                                            <option value="PA">PA</option>
                                                            <option value="PE">PE</option>
                                                            <option value="RC">RC</option>
                                                            <option value="TI">TI</option>
                                                            <option value="NIT">NIT</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>N° Documento *</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={documentoPaciente}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-1">
                                                    <div className="form-group">
                                                        <label>&nbsp;</label>
                                                        <button
                                                            type="button"
                                                            className="btn btn-info form-control"
                                                            onClick={() => setShowModalPaciente(true)}
                                                            disabled={origenNavegacion === 'presupuesto'}
                                                            title={origenNavegacion === 'presupuesto' ? 'El paciente viene del presupuesto y no puede cambiarse' : ''}
                                                        >
                                                            <i className="fas fa-search"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            {/* Sección Presupuesto Activo */}
                                            {pacienteId && presupuestosActivos.length > 0 && (
                                                <div className="card card-outline card-success mb-3">
                                                    <div className="card-header py-2">
                                                        <h6 className="mb-0"><i className="fas fa-wallet mr-1"></i> <b>Presupuesto Activo</b></h6>
                                                    </div>
                                                    <div className="card-body py-2">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group mb-2">
                                                                    <label>Seleccionar Presupuesto Activo</label>
                                                                    <select 
                                                                        className="form-control"
                                                                        value={presupuestoActivo ? presupuestoActivo.id : ''}
                                                                        onChange={handleSeleccionPresupuestoActivo}
                                                                    >
                                                                        <option value="">-- Sin presupuesto --</option>
                                                                        {presupuestosActivos.map(p => (
                                                                            <option key={p.id} value={p.id}>
                                                                                #{p.numero_presupuesto || p.id} - Pendiente: ${parseFloat(p.saldo_disponible || 0).toLocaleString('es-CO', {minimumFractionDigits: 2})}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 d-flex align-items-end mb-2">
                                                                {presupuestoActivo && (
                                                                    <div>
                                                                        <span className="factura-soft-banner">
                                                                            <i className="fas fa-money-bill-wave mr-1"></i>
                                                                            Saldo Pendiente: ${parseFloat(saldoDisponible || 0).toLocaleString('es-CO', {minimumFractionDigits: 2})}
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {presupuestoActivo && (
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    {!copiarItemsPresupuesto ? (
                                                                        <button 
                                                                            type="button" 
                                                                            className="btn btn-outline-success btn-sm"
                                                                            onClick={copiarItemsDePresupuesto}
                                                                        >
                                                                            <i className="fas fa-copy mr-1"></i> Copiar ítems del presupuesto
                                                                        </button>
                                                                    ) : (
                                                                        <span className="text-success">
                                                                            <i className="fas fa-check-circle mr-1"></i> Ítems copiados del presupuesto
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {/* Validación en tiempo real: total excede saldo */}
                                                        {presupuestoActivo && totalPagar > saldoDisponible && (
                                                            <div className="row mt-2">
                                                                <div className="col-md-12">
                                                                    <div className="alert mb-0 py-2 factura-soft-alert">
                                                                        <i className="fas fa-exclamation-triangle mr-1"></i>
                                                                        El valor total de la factura (${parseFloat(totalPagar || 0).toLocaleString('es-CO', {minimumFractionDigits: 2})}) excede el saldo pendiente (${parseFloat(saldoDisponible || 0).toLocaleString('es-CO', {minimumFractionDigits: 2})})
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                            <hr />

                                            <h5 className="factura-section-title">
                                                <span className="title-icon"><i className="fas fa-receipt"></i></span>
                                                Datos de Factura
                                            </h5>

                                            <div className="row">
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Fecha*</label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={fecha}
                                                            onChange={(e) => {
                                                                setFecha(e.target.value);
                                                                if (tipoPago === 'contado') {
                                                                    setVencimiento(e.target.value);
                                                                }
                                                            }}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Tipo de Pago *</label>
                                                        <select
                                                            className="form-control"
                                                            value={tipoPago}
                                                            onChange={(e) => {
                                                                setTipoPago(e.target.value);
                                                                if (e.target.value === 'contado') {
                                                                    setVencimiento(fecha);
                                                                }
                                                            }}
                                                            required
                                                        >
                                                            <option value="contado">Contado</option>
                                                            <option value="credito">Crédito</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Vencimiento *</label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={vencimiento}
                                                            onChange={(e) => setVencimiento(e.target.value)}
                                                            disabled={tipoPago === 'contado'}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Profesional *</label>
                                                        <select
                                                            className="form-control"
                                                            value={profesional}
                                                            onChange={(e) => setProfesional(e.target.value)}
                                                            required
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {profesionales.map(prof => (
                                                                <option key={prof.id} value={prof.id}>{prof.name} {prof.lastname}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Método de Pago *</label>
                                                        <select
                                                            className="form-control"
                                                            value={metodoPago}
                                                            onChange={(e) => setMetodoPago(e.target.value)}
                                                            required
                                                        >
                                                            <option value="10">Efectivo</option>
                                                            <option value="42">Consignación bancaria</option>
                                                            <option value="1">Instrumento no definido</option>
                                                            <option value="20">Cheque</option>
                                                            <option value="30">Transferencia Crédito</option>
                                                            <option value="31">Transferencia Débito</option>
                                                            <option value="45">Transferencia Crédito Bancario</option>
                                                            <option value="47">Transferencia Débito Bancaria</option>
                                                            <option value="48">Tarjeta Crédito</option>
                                                            <option value="49">Tarjeta Débito</option>
                                                            <option value="ZZZ">Acuerdo mutuo</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            <div className="form-group">
                                                {/* Primera fila: Clasificación dinámica */}
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <label>Clasificación</label>
                                                        <div className="chip-row mb-2">
                                                            <button
                                                                type="button"
                                                                className={`chip-filter ${clasificacionFiltro === '' ? 'active' : ''}`}
                                                                onClick={() => setClasificacionFiltro('')}
                                                            >
                                                                Todas
                                                            </button>
                                                            {getClasificacionesDinamicas().map((clas) => (
                                                                <button
                                                                    key={clas}
                                                                    type="button"
                                                                    className={`chip-filter ${clasificacionFiltro === clas ? 'active' : ''}`}
                                                                    onClick={() => setClasificacionFiltro(clas)}
                                                                >
                                                                    {clas}
                                                                </button>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                {/* Segunda fila: Selector con búsqueda integrada + Botón */}
                                                <div className="row mt-2">
                                                    <div className="col-md-10">
                                                        <label>Selecciona el Servicio a Facturar</label>
                                                        <div style={{ position: 'relative' }}>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Buscar y seleccionar servicio (código o nombre)..."
                                                                value={buscarServicio}
                                                                onFocus={() => setMostrarOpcionesServicio(true)}
                                                                onBlur={() => setTimeout(() => setMostrarOpcionesServicio(false), 150)}
                                                                onChange={(e) => {
                                                                    setBuscarServicio(e.target.value);
                                                                    setProductoSeleccionado('');
                                                                    setMostrarOpcionesServicio(true);
                                                                }}
                                                            />

                                                            {mostrarOpcionesServicio && (
                                                                <div
                                                                    className="shadow-sm"
                                                                    style={{
                                                                        position: 'absolute',
                                                                        zIndex: 1000,
                                                                        width: '100%',
                                                                        maxHeight: '260px',
                                                                        overflowY: 'auto',
                                                                        background: '#fff',
                                                                        border: '1px solid #dee2e6',
                                                                        borderRadius: '10px',
                                                                        marginTop: '4px'
                                                                    }}
                                                                >
                                                                    {getListaPreciosFiltrada().length === 0 ? (
                                                                        <div style={{ padding: '10px 12px', color: '#8c8c8c', fontSize: '0.85rem' }}>
                                                                            No hay servicios para tu búsqueda.
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            {getListaPreciosFiltrada().slice(0, 30).map(item => (
                                                                                <button
                                                                                    key={item.id}
                                                                                    type="button"
                                                                                    onMouseDown={() => {
                                                                                        setProductoSeleccionado(item.id);
                                                                                        setBuscarServicio(`${item.codigo || ''} - ${item.nombre || ''}`.trim());
                                                                                        setMostrarOpcionesServicio(false);
                                                                                    }}
                                                                                    style={{
                                                                                        display: 'block',
                                                                                        width: '100%',
                                                                                        textAlign: 'left',
                                                                                        border: 'none',
                                                                                        background: 'transparent',
                                                                                        padding: '8px 12px',
                                                                                        borderBottom: '1px solid #f3f3f3',
                                                                                        cursor: 'pointer'
                                                                                    }}
                                                                                >
                                                                                    <span style={{ fontWeight: 600, color: '#323a45' }}>{item.codigo}</span>
                                                                                    <span style={{ color: '#8c8c8c' }}> - {item.nombre}</span>
                                                                                </button>
                                                                            ))}
                                                                            {getListaPreciosFiltrada().length > 30 && (
                                                                                <div style={{ padding: '8px 12px', color: '#8c8c8c', fontSize: '0.75rem', background: '#fafafa', borderTop: '1px solid #f0f0f0' }}>
                                                                                    Mostrando 30 de {getListaPreciosFiltrada().length} resultados. Escribe más para refinar.
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label>&nbsp;</label>
                                                        <button
                                                            type="button"
                                                            className="btn btn-info btn-block"
                                                            onClick={agregarServicio}
                                                            disabled={!productoSeleccionado}
                                                        >
                                                            Agregar Servicio
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            {productos.length > 0 && (
                                                <div className="table-responsive">
                                                    <table className="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: '15%' }}>Clasificación</th>
                                                                <th style={{ width: '25%' }}>Descripción</th>
                                                                <th style={{ width: '8%' }}>Cantidad</th>
                                                                <th style={{ width: '12%' }}>Precio</th>
                                                                <th style={{ width: '8%' }}>Desc. %</th>
                                                                <th style={{ width: '10%' }}>Impuesto</th>
                                                                <th style={{ width: '15%' }}>Total</th>
                                                                <th style={{ width: '7%' }}>Acciones</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {productos.map(producto => (
                                                                <tr key={producto.id}>
                                                                    <td>{producto.clasificacion || 'N/A'}</td>
                                                                    <td>{producto.descripcion}</td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            value={producto.cantidad}
                                                                            onChange={(e) => actualizarProducto(producto.id, 'cantidad', e.target.value)}
                                                                            min="1"
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            value={producto.precio}
                                                                            onChange={(e) => actualizarProducto(producto.id, 'precio', e.target.value)}
                                                                            step="0.01"
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            value={producto.porcentaje}
                                                                            onChange={(e) => actualizarProducto(producto.id, 'porcentaje', e.target.value)}
                                                                            step="0.01"
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            value={producto.impuesto}
                                                                            onChange={(e) => actualizarProducto(producto.id, 'impuesto', e.target.value)}
                                                                            step="0.01"
                                                                        />
                                                                    </td>
                                                                    <td>$ {parseFloat(producto.total || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                                    <td style={{ textAlign: 'center' }}>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-danger btn-sm"
                                                                            onClick={() => eliminarProducto(producto.id)}
                                                                            title="Eliminar"
                                                                        >
                                                                            <i className="fas fa-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}

                                            <div className="d-flex align-items-center mt-2">
                                                <div style={{ width: '68%' }}></div>
                                                <div style={{ width: '10%', textAlign: 'right', paddingRight: '10px' }}>
                                                    <label className="mb-0"><b>Subtotal:</b></label>
                                                </div>
                                                <div style={{ width: '15%' }}>
                                                    <input type="text" className="form-control text-right" value={`$ ${parseFloat(totalBruto || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} readOnly />
                                                </div>
                                                <div style={{ width: '7%' }}></div>
                                            </div>

                                            <div className="d-flex align-items-center mt-2">
                                                <div style={{ width: '68%' }}></div>
                                                <div style={{ width: '10%', textAlign: 'right', paddingRight: '10px' }}>
                                                    <label className="mb-0"><b>Descuento:</b></label>
                                                </div>
                                                <div style={{ width: '15%' }}>
                                                    <input type="text" className="form-control text-right" value={`$ ${parseFloat(totalDescuento || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} readOnly />
                                                </div>
                                                <div style={{ width: '7%' }}></div>
                                            </div>

                                            <div className="d-flex align-items-center mt-2">
                                                <div style={{ width: '68%' }}></div>
                                                <div style={{ width: '10%', textAlign: 'right', paddingRight: '10px' }}>
                                                    <label className="mb-0"><b>IVA:</b></label>
                                                </div>
                                                <div style={{ width: '15%' }}>
                                                    <input type="text" className="form-control text-right" value={`$ ${parseFloat(totalIVA || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} readOnly />
                                                </div>
                                                <div style={{ width: '7%' }}></div>
                                            </div>

                                            <div className="d-flex align-items-center mt-2">
                                                <div style={{ width: '68%' }}></div>
                                                <div style={{ width: '10%', textAlign: 'right', paddingRight: '10px' }}>
                                                    <label className="mb-0"><b>Total:</b></label>
                                                </div>
                                                <div style={{ width: '15%' }}>
                                                    <input type="text" className="form-control text-right" value={`$ ${parseFloat(totalPagar || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} readOnly />
                                                </div>
                                                <div style={{ width: '7%' }}></div>
                                            </div>

                                            <hr />

                                            <div className="form-group">
                                                <label>Observaciones</label>
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    value={observaciones}
                                                    onChange={(e) => setObservaciones(e.target.value)}
                                                    placeholder="Observaciones adicionales"
                                                />
                                            </div>

                                            <div className="form-group">
                                                <button type="submit" className="btn btn-success" disabled={presupuestoActivo && totalPagar > saldoDisponible}>
                                                    <i className="fas fa-save"></i> Guardar Factura
                                                </button>
                                                <Link to="/listado-facturas" className="btn btn-secondary ml-2">
                                                    <i className="fas fa-times"></i> Cancelar
                                                </Link>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                {/* Modal de Éxito — mismo lenguaje visual que modales industriales (documentos soporte / NC) */}
                <Modal
                    show={showModalExito}
                    onHide={handleCloseModalExito}
                    centered
                    dialogClassName="cf-ne-exito-dialog"
                    contentClassName="cf-ne-exito-content"
                    backdropClassName="cf-ne-exito-backdrop"
                >
                    <Modal.Header closeButton closeVariant="dark" className="cf-ne-exito-head">
                        <Modal.Title className="d-flex align-items-center gap-2 mb-0">
                            <span className="d-inline-flex align-items-center justify-content-center rounded-circle bg-success text-white" style={{ width: 32, height: 32, fontSize: '0.85rem' }}>
                                <i className="fas fa-check"></i>
                            </span>
                            Factura guardada
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="pt-3 pb-3">
                        <div className="cf-ne-alert-success-soft mb-3">
                            <i className="fas fa-check-circle mr-2 text-success"></i>
                            <strong>Listo.</strong> La factura no electrónica se registró correctamente en el sistema.
                        </div>
                        <div className="cf-ne-alert-info-soft mb-0">
                            <strong>Número de factura:</strong>{' '}
                            <span className="font-weight-bold">{numeroFacturaCreada || '—'}</span>
                        </div>
                    </Modal.Body>

                    <Modal.Footer className="bg-light border-top d-flex flex-wrap justify-content-center" style={{ gap: '10px' }}>
                        <Button
                            variant="info"
                            onClick={() => {
                                handleCloseModalExito();
                                const url = `${window.location.origin}/smile/#/vista-previa-factura-no-electronica/${facturaIdCreada}`;
                                window.open(url, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
                            }}
                        >
                            <i className="fas fa-eye mr-2"></i> Ver factura
                        </Button>
                        {pacienteIdParaCartera && (
                            <Button
                                variant="secondary"
                                onClick={() => {
                                    handleCloseModalExito();
                                    history.push(`/estado-cuenta-paciente/${pacienteIdParaCartera}`);
                                }}
                            >
                                <i className="fas fa-wallet mr-2"></i> Cartera del paciente
                            </Button>
                        )}
                        <Button
                            variant="outline-secondary"
                            onClick={() => {
                                handleCloseModalExito();
                                if (origenNavegacion === 'presupuesto') {
                                    history.push('/listado-presupuestos');
                                } else {
                                    history.push('/listado-facturas');
                                }
                            }}
                        >
                            <i className="fas fa-arrow-left mr-2"></i>
                            {origenNavegacion === 'presupuesto' ? 'Volver a presupuestos' : 'Volver a facturas'}
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Footer showToast={false} delay={0} />

                {/* Modal de selección de paciente — scroll en tabla + paginación visible */}
                {showModalPaciente && (() => {
                    const pacientesFiltradosLista = getPacientesFiltrados();
                    const totalPacientesLista = pacientesFiltradosLista.length;
                    const totalPaginasLista = getTotalPaginas();
                    const paginaLista = totalPaginasLista > 0 ? Math.min(Math.max(1, paginaActual), totalPaginasLista) : 1;
                    const idxInicio = totalPacientesLista === 0 ? 0 : (paginaLista - 1) * pacientesPorPagina + 1;
                    const idxFin = Math.min(paginaLista * pacientesPorPagina, totalPacientesLista);
                    return (
                        <div className="modal fade show cf-ne-modal-paciente" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 1055, overflowY: 'auto' }} tabIndex="-1" role="dialog">
                            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                                <div className="modal-content border-0">
                                    <div className="modal-header cf-ne-paciente-head">
                                        <h5 className="modal-title mb-0">
                                            <i className="fas fa-user-injured mr-2 text-info"></i>
                                            Seleccionar paciente
                                        </h5>
                                        <button
                                            type="button"
                                            className="close"
                                            onClick={() => setShowModalPaciente(false)}
                                            aria-label="Cerrar"
                                        >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body cf-ne-paciente-body">
                                        <div className="form-group mb-3">
                                            <label className="mb-1 d-block small font-weight-bold text-muted">Buscar</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Buscar por nombre o documento"
                                                value={busquedaPaciente}
                                                onChange={(e) => setBusquedaPaciente(e.target.value)}
                                                autoFocus
                                            />
                                        </div>
                                        <div className="cf-ne-paciente-table-wrap table-responsive">
                                            <table className="table table-hover mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Nombre</th>
                                                        <th>Documento</th>
                                                        <th className="text-center" style={{ width: 120 }}>Acción</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {totalPacientesLista === 0 ? (
                                                        <tr>
                                                            <td colSpan="3" className="text-center text-muted py-4">
                                                                No hay pacientes que coincidan con la búsqueda.
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        getPacientesPaginados().map((paciente) => (
                                                            <tr key={paciente.id}>
                                                                <td>
                                                                    {`${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim()}
                                                                </td>
                                                                <td>{paciente.numero_documento}</td>
                                                                <td className="text-center">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-info"
                                                                        onClick={() => seleccionarPaciente(paciente)}
                                                                    >
                                                                        Seleccionar
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="cf-ne-paciente-pag d-flex flex-wrap align-items-center justify-content-between gap-2 pt-3 mt-2 border-top">
                                            <small className="text-muted mb-0">
                                                {totalPacientesLista === 0
                                                    ? '0 pacientes'
                                                    : `Mostrando ${idxInicio}–${idxFin} de ${totalPacientesLista}`}
                                            </small>
                                            {totalPaginasLista > 1 && (
                                                <div className="d-flex align-items-center flex-wrap" style={{ gap: 8 }}>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-secondary"
                                                        disabled={paginaLista <= 1}
                                                        onClick={() => setPaginaActual((p) => Math.max(1, p - 1))}
                                                    >
                                                        « Anterior
                                                    </button>
                                                    <span className="small font-weight-bold text-secondary px-1">
                                                        {paginaLista} / {totalPaginasLista}
                                                    </span>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-secondary"
                                                        disabled={paginaLista >= totalPaginasLista}
                                                        onClick={() => setPaginaActual((p) => Math.min(totalPaginasLista, p + 1))}
                                                    >
                                                        Siguiente »
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })()}
            </div>
        );
    } else {
        return <Loading />;
    }
}

export default CrearFacturaNoElectronica;